import { getBaseUrl } from '../../keycloak/utils/get-base-url';
import { useKeycloakContext } from '../hooks/use-keycloak-context';

export function useAssetPath(path: string) {
    const isKeycloakContext = useKeycloakContext();

    if (!isKeycloakContext || path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    return `${getBaseUrl()}${path}`;
}
